export default __webpack_public_path__ + "static/media/flag-5.be1354c5.gif";